export default __webpack_public_path__ + "images/0x71319ee6f41598412701f0d3e987bb1d74921fb3.png";